package com.milta.core.localization.translations.ro

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Tură nouă",
    stepDeliveries = "Livrări",
    stepDrivers = "Șoferi",
    stepDistribution = "Repartizare",
    deliveriesSummary = "%1 livrări · %2 colete",
    deliveriesSummaryOne = "1 livrare · %1 colete",
    toFixCount = "%1 de corectat",
    allAddressesCorrect = "Toate adresele sunt corecte",
    filterAll = "Toate %1",
    filterToFix = "De corectat %1",
    fixAddressesToContinue = "Corectați %1 adrese pentru a continua",
    fixOneAddressToContinue = "Corectați 1 adresă pentru a continua",
    continueWithDeliveries = "Continuați · %1 livrări",
    continueWithOneDelivery = "Continuați · 1 livrare",
    chooseAtLeastOneDriver = "Alegeți cel puțin un șofer",
    reasonMissingHouseNumber = "Lipsește numărul străzii",
    reasonNotFound = "Adresă negăsită",
    reasonUnverified = "Verificare imposibilă, încercați din nou",
    missingHouseNumberExample = "Lipsește numărul străzii. Exemplu: %1",
    notFoundHelp = "Adresă negăsită. Verificați strada, numărul și codul poștal.",
    unverifiedHelp = "Adresa nu a putut fi verificată momentan. Încercați din nou peste câteva momente.",
    addToExistingHint = "Se adaugă la cele %1 livrări deja din listă.",
    importFileAction = "Importați un fișier",
    importFileHint = "Excel (.xlsx, .xls), CSV sau PDF",
    manualEntryAction = "Introducere manuală",
    manualEntryHint = "Nume, adresă, telefon, oră limită",
    addDeliveryTitle = "Adăugați o livrare",
    deleteDelivery = "Ștergeți livrarea",
    addedFileAnalysing = "Se analizează %1…",
    addedFileFailed = "Importul %1 nu a reușit. Nu a fost adăugată nicio livrare.",
    errorAddressesToFix = "Unele adrese nu au fost validate: corectați-le în lista „De corectat”.",
    errorAddressesCheckRetry = "Verificarea adreselor nu a reușit. Încercați din nou peste câteva momente.",
    errorBatchAlreadyDispatched = "Această repartizare a fost deja trimisă șoferilor.",
    editDeliveryTitle = "Modificați livrarea",
    zoneLabel = "Zona %1",
    workloadBalanced = "Timpi de lucru echilibrați între șoferi",
    workloadGap = "Diferență de timp de lucru între șoferi: %1",
    importAddedFromScan = "%1 livrări adăugate din scanare",
    importAddedOneFromScan = "1 livrare adăugată din scanare",
    importAddedFromPdf = "%1 livrări adăugate din PDF",
    importAddedOneFromPdf = "1 livrare adăugată din PDF",
    importAddedFromSpreadsheet = "%1 livrări adăugate din fișierul Excel",
    importAddedOneFromSpreadsheet = "1 livrare adăugată din fișierul Excel",
    importAddedToFixSuffix = ", dintre care %1 de corectat",
    deliverySearchOpenAction = "Căutați o livrare",
    deliverySearchCount = "%1 din %2",
    deliverySearchCountToFix = "%1 din %2 de corectat",
    deliverySearchEmptyTitle = "Nicio livrare nu corespunde",
    deliverySearchEmptyToFixHint = "Nicio livrare de corectat nu corespunde. Încercați la „Toate”.",
)
